module.exports = __webpack_public_path__ + "img/glassquality_2.d5c1b136.png";